import { useSelector } from '../../../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../../../app.store';

const highlightedBoundarySelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryHighlight.highlightedBoundary;
export const useHighlightedBoundarySelector = () => useSelector(highlightedBoundarySelector);

const highlightedBoundaryTerritorySelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryHighlight.highlightedBoundaryTerritory;
export const useHighlightedBoundaryTerritorySelector = () => useSelector(highlightedBoundaryTerritorySelector);
